import { Button } from 'components/base/material-ui/Button';
import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { PERM } from 'utils/can';
import { translate } from 'utils/helper';
import { refreshServiceWorker, subscribeServiceWorkerUpdate } from 'utils/serviceWorkerUpdates';

const UPDATE_CONTAINER_ID = 'service-worker-update';
const UPDATE_TOAST_ID = 'new-app-version';
let updateDismissed = false;
let updateIsAvailable = false;

const UpdateMessage = () => {
	const [refreshing, setRefreshing] = useState(false);
	return (
		<div className="service-worker-update-message">
			<p>{translate('service.worker.update.message')}</p>
			{!PERM.IS_ADMIN() && <p>{translate('service.worker.update.logoutWarning')}</p>}
			<Button
				mode="primary"
				size="small"
				disabled={refreshing}
				onClick={() => {
					setRefreshing(true);
					refreshServiceWorker();
				}}
			>
				{refreshing ? translate('service.worker.update.refreshing') : translate('service.worker.update.button')}
			</Button>
		</div>
	);
};

const ServiceWorkerUpdatePopup = () => {
	useEffect(() => subscribeServiceWorkerUpdate((available) => {
		updateIsAvailable = available;
		if (!available) {
			toast.dismiss({ id: UPDATE_TOAST_ID, containerId: UPDATE_CONTAINER_ID });
			updateDismissed = false;
			return;
		}
		if (available && !updateDismissed) {
			toast(<UpdateMessage />, {
				containerId: UPDATE_CONTAINER_ID,
				toastId: UPDATE_TOAST_ID,
				onClose: () => {
					updateDismissed = updateIsAvailable;
				},
			});
		}
	}), []);

	return (
		<ToastContainer
			containerId={UPDATE_CONTAINER_ID}
			position="bottom-right"
			toastClassName="service-worker-update-toast"
			autoClose={false}
			closeButton
			closeOnClick={false}
			draggable={false}
			hideProgressBar
		/>
	);
};

export default ServiceWorkerUpdatePopup;
